var _style, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreProcessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Machine Learning - Feature learning by Sasha is Sasha. Public Domain. 2017") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "sashaissasha.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 71.1,
    cy: 69.4,
    r: 17.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.8,43.7c9.5,0,17.1-7.7,17.1-17.1S80.2,9.5,70.8,9.5s-17.1,7.7-17.1,17.1S61.3,43.7,70.8,43.7z M70.8,15.9 c5.9,0,10.7,4.8,10.7,10.7c0,5.9-4.8,10.7-10.7,10.7s-10.7-4.8-10.7-10.7C60.1,20.7,64.9,15.9,70.8,15.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.5,
    cy: 26.6,
    r: 17.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.3,
    cy: 69.4,
    r: 17.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreProcessing);
export default __webpack_public_path__ + "static/media/pre_processing.fb3f4511129e5b035617788093204bab.svg";
export { ForwardRef as ReactComponent };